/**
 * Enum sử dụng chi đầu tư phát triển
 * nnduc 30/01/2024
 */
export default {
  All: null,
  Used: true,
  Stoped: false,
};
